// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";

function CryptoCurrencyNetworks(props) {
  var currencyVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userCurrency);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.cryptoCurrencyNetworks);
  var setCryptoCurrencyNetworks = match$1[1];
  var dropdownOptions = Core__Option.getOr(Utils$OrcaPaymentPage.currencyNetworksDict[currencyVal], []).map(function (item) {
        return {
                value: item,
                label: Utils$OrcaPaymentPage.toSpacedUpperCase(item, "_")
              };
      });
  var initialValue = Core__Option.getOr(dropdownOptions[0], {
        value: "",
        label: ""
      }).value;
  React.useEffect((function () {
          setCryptoCurrencyNetworks(function (param) {
                return initialValue;
              });
        }), [initialValue]);
  return React.createElement(DropdownField$OrcaPaymentPage.make, {
              appearance: match.config.appearance,
              value: match$1[0],
              setValue: setCryptoCurrencyNetworks,
              fieldName: match.localeString.currencyNetwork,
              options: dropdownOptions,
              disabled: false
            });
}

var make = CryptoCurrencyNetworks;

export {
  make ,
}
/* react Not a pure module */
